import React, { PropsWithChildren } from "react";
//#region types
import { ViewPanelContentProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ViewPanelContent: React.FC<PropsWithChildren<ViewPanelContentProps>> = (props) => {
  return (
    <>
      <Grid
        id={props.elementId}
        container
        className={clsx(
          cssExports.viewPanelContent,
          props.isCanvasContent ? cssExports.canvas : "",
          props.classes?.content
        )}
      >
        {props.children}
      </Grid>
      {props.footerLeftContent || props.footerContainerId || props.footerRightContent ? (
        <Grid item container alignItems="center" className={cssExports.viewPanelFooter}>
          <Grid item>{props.footerLeftContent}</Grid>
          {props.footerContainerId && (
            <Grid item container xs justifyContent="center" id={props.footerContainerId}></Grid>
          )}
          <Grid item className={cssExports.footerRightContent}>
            {props.footerRightContent}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default ViewPanelContent;
